'use strict';

var timestampToParts = require('./timestampToParts.cjs');

const parseTimestampIntervalToISODatePartInterval = ({
  timestampInterval: { start, end },
  timeZone,
  inclusiveEnd = true
}) => {
  if (!inclusiveEnd) {
    return {
      start: timestampToParts({ timestamp: start, timeZone }).date,
      end: timestampToParts({
        timestamp: end - 1,
        timeZone
      }).date
    };
  }
  return {
    start: timestampToParts({ timestamp: start, timeZone }).date,
    end: timestampToParts({ timestamp: end, timeZone }).date
  };
};

module.exports = parseTimestampIntervalToISODatePartInterval;
//# sourceMappingURL=parseTimestampIntervalToISODatePartInterval.cjs.map
